import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class ApplyProduktionsMallAndUtbytessimuleraEgenskogCommand extends BasicCommand<ApplyProduktionsMallAndUtbytessimuleraEgenskogCommand> {
    get primaryKey(): IPrimaryKey<ApplyProduktionsMallAndUtbytessimuleraEgenskogCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    produktionsmallId: number;
    utbytessimulera: boolean;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ApplyProduktionsMallAndUtbytessimuleraEgenskogCommand";
    constructor(init: (instance: ApplyProduktionsMallAndUtbytessimuleraEgenskogCommand) => void) {
        super(ApplyProduktionsMallAndUtbytessimuleraEgenskogCommand.$type,
            ApplyProduktionsMallAndUtbytessimuleraEgenskogCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
